import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService, Company } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-edit-dialog',
  templateUrl: './companies-edit-dialog.component.html',
  styleUrls: ['./companies-edit-dialog.component.scss'],
})
export class CompaniesEditDialogComponent {
  company?: Company;
  company_edit_form_group: FormGroup = this.form_service.company_edit_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_company_edit_running: boolean = false;

  constructor(
    private form_service: FormService,
    private dialog_ref: MatDialogRef<CompaniesEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private companies_service: CompaniesService,
    private error_service: ErrorService,
  ) {
    this.company = data.company;
  }

  ngOnInit(): void {
    this.company_edit_form_group.get(this.form_service.business_name_label)?.setValue(this.company?.business_name);
    this.company_edit_form_group.get(this.form_service.vat_label)?.setValue(this.company?.vat);
    this.company_edit_form_group.get(this.form_service.website_label)?.setValue(this.company?.website);
    this.company_edit_form_group
      .get(this.form_service.sales_network_id_label)
      ?.setValue(this.company?.sales_network_id);
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    if (this.isFormValid() && this.company?.company_id) {
      const company = this.companies_service.buildCompanyFromForm(
        this.company_edit_form_group,
        this.company?.min_revenue || 0,
        this.company?.max_revenue || 0,
      );
      this.editCompany(this.company.company_id, company);
    }
  }

  editCompany(company_id: string, company: Company): void {
    this.is_company_edit_running = true;
    this.companies_service.edit(company_id, company).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_company_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_company_edit_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.company_edit_form_group);
  }
}
